import React from 'react';
import Desktop from "./Desktop";
import DesktopHost from "./DesktopHost";
import Mobile from "../../Auth/Header/Mobile";
import useWindowSize from "../../common/useWindowSize";
import { mobileWidth } from "../../../utils/css/sizes";
import { useSelector } from "react-redux";
import * as guestsSelectors from "../../../store/selectors/guestsSelectors";

const Header: React.FC = () => {
	const [width] = useWindowSize();
	const guestId = useSelector(guestsSelectors.guestIdSelector);
	const locationForHeader = window.location.href.split("site")?.[1];
  
	return width <= mobileWidth ? (
	  <Mobile />
	) : locationForHeader === `/guest/${guestId}/salon` ||
	  locationForHeader === `/guest/${guestId}/profile` ||
	  locationForHeader === `/guest/${guestId}/profile/profile` ||
	  locationForHeader === `/guest/${guestId}/profile/salon` ? (
	  <Desktop />
	) : (
	  <DesktopHost />
	);
};

export default Header;
